import { ActionTree, ActionContext } from 'vuex';

import { careClient } from '@/http-client';
import { camelToSnake } from '@/utils';

import { RootStateI } from '../state';
import { AppointmentState, AppointmentI } from './state';

const actions: ActionTree<AppointmentState, RootStateI> = {
  async add(
    context: ActionContext<AppointmentState, RootStateI>,
    payload: AppointmentI,
  ) {
    await careClient.post('/api/appointments/add', camelToSnake(payload));
  },
  async getAppointments(
    context: ActionContext<AppointmentState, RootStateI>,
    payload: AppointmentI,
  ) {
    context.commit('setAppointments', []);
    const url = `/api/appointments/get?start=${payload.start}&end=${payload.end}`;
    const response = await careClient.get(url);
    context.commit('setAppointments', response.data);
  },
  async getAppointment(
    context: ActionContext<AppointmentState, RootStateI>,
    payload: number | string,
  ) {
    context.commit('setAppointment', null);
    const url = `/api/appointments/get/${payload}`;
    const response = await careClient.get(url);
    context.commit('setAppointment', response.data);
  },
  async removeAppointment(
    context: ActionContext<AppointmentState, RootStateI>,
    payload: number | string,
  ) {
    context.commit('setAppointment', null);
    await careClient.get(`/api/appointments/remove/${payload}`);
  },
};

export default actions;
